import React, { useEffect, useState } from "react";
import Input from "../shared/Input";
import topTost from "../../utils/topTost";
import { useLocation } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
import Swal from "sweetalert2";
import TextArea from "../shared/TextArea";
import SelectDropdown from "../shared/SelectDropdown";

const EmailContent = (permission) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailformData, setEmailFormData] = useState({
    id: "1",
    mail_engine: "",
    email_protocol: "",
    email: "",
    email_charset: "",
    email_signature: "",
    predefined_header: "",
    predefined_footer: "",
    enable_email_queue: "",
    no_attachments_in_queue: "",
  });

  const handleChange = (name, value) => {
    setEmailFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchDetails = async () => {
    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const result = await fetchData("email-settings", "", "get");

      if (result && result.data) {
        setEmailFormData(result.data);
      } else {
        console.warn("data not found.");
        setEmailFormData({});
      }
    } catch (error) {
      console.error("Failed to fetch:", error);
      setEmailFormData({});
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("moduleId", M_id);
      formData.append("mail_engine", emailformData.mail_engine || "");
      formData.append("email_protocol", emailformData.email_protocol || "");
      formData.append("email", emailformData.email || "");
      formData.append("email_charset", emailformData.email_charset || "");
      formData.append("email_signature", emailformData.email_signature || "");
      formData.append(
        "predefined_header",
        emailformData.predefined_header || ""
      );
      formData.append(
        "predefined_footer",
        emailformData.predefined_footer || ""
      );
      formData.append(
        "enable_email_queue",
        emailformData.enable_email_queue || ""
      );
      formData.append(
        "no_attachments_in_queue",
        emailformData.no_attachments_in_queue || ""
      );
      const result = await fetchFormData("email-settings", formData, "POST");
      if (result.success || result.code === 200) {
        topTost({
          title: result.message,
          icon: "success",
        });
      } else {
        throw new Error("Update failed");
      }
    } catch (error) {
      console.error("Error updating company profile:", error);
      topTost({ title: "Failed to update profile", icon: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="col-lg-12">
      <div className="card stretch stretch-full">
        <hr className="mt-0" />

        <div className="card-body general-info py-40">
          <div className="mb-5 d-flex align-items-center justify-content-between">
            <h5 className="fw-bold mb-0 me-4">
              <span className="d-block mb-2">Email Settings</span>
            </h5>
          </div>
          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-md-6">
              <Input
                label="Mail Engine"
                name="mail_engine"
                value={emailformData.mail_engine || ""}
                onChange={handleChange}
                placeholder="Enter Mail"
                icon="feather-hash"
              />
            </div>
            <div className="col-md-6">
              <Input
                label="Email Protocal"
                name="email_protocol"
                value={emailformData.email_protocol || ""}
                onChange={handleChange}
                placeholder="Enter Email Protocal"
                icon="feather-hash"
              />
            </div>
            <div className="col-md-6">
              <Input
                label="Email"
                name="email"
                value={emailformData.email || ""}
                onChange={handleChange}
                placeholder=" Enter Email"
                icon="feather-user"
              />
            </div>
            <div className="col-md-6">
              <Input
                label="Email Charset"
                name="email_charset"
                value={emailformData.email_charset || ""}
                onChange={handleChange}
                placeholder="Enter Email Charset"
                icon="feather-message-square"
              />
            </div>
            {/* <div className="col-md-6">
              <Input
                label="Email Signature"
                name="email_signature"
                value={emailformData.email_signature || ""}
                onChange={handleChange}
                placeholder="Enter Signature"
                icon="feather-file-text"
              />
            </div> */}
            <div className="row">
              <div className="col-md-6">
                <TextArea
                  label="Predefined Header"
                  name="predefined_header"
                  value={emailformData.predefined_header || ""}
                  onChange={(e) =>
                    setEmailFormData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  icon="feather-message-square"
                />
              </div>
              <div className="col-md-6">
                <TextArea
                  label="Predefined Footer"
                  name="predefined_footer"
                  value={emailformData.predefined_footer || ""}
                  onChange={(e) =>
                    setEmailFormData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  icon="feather-file-text"
                />
              </div>
            </div>

            <hr className="my-5" />

            <div className="mb-4">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2"> Email Queue</span>
              </h5>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label className="fw-semibold">
                  <span className="me-2">Enable Email Queue</span>
                </label>
                <div className="col-md-12">
                  <SelectDropdown
                    options={[
                      { value: "yes", label: "Yes" },
                      { value: "no", label: "No" },
                    ]}
                    selectedOption={
                      [
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ].find(
                        (opt) =>
                          opt.value ===
                          setEmailFormData.exclude_attachments_from_queue
                      ) || null
                    }
                    defaultSelect="Select Option"
                    onSelectOption={(option) => {
                      setEmailFormData((prev) => ({
                        ...prev,
                        exclude_attachments_from_queue: option.value,
                      }));
                    }}
                    icon="feather-mail"
                    value={emailformData.exclude_attachments_from_queue}
                    required
                  />
                </div>
              </div>

              <div className="col-md-6">
                <label className="fw-semibold">
                  <span className="me-2">
                    Do not add emails with attachments in the queue
                  </span>
                </label>
                <div className="col-md-12">
                  <SelectDropdown
                    options={[
                      { value: "yes", label: "Yes" },
                      { value: "no", label: "No" },
                    ]}
                    selectedOption={
                      [
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ].find(
                        (opt) =>
                          opt.value ===
                          setEmailFormData.exclude_attachments_from_queue
                      ) || null
                    }
                    defaultSelect="Select Option"
                    onSelectOption={(option) => {
                      setEmailFormData((prev) => ({
                        ...prev,
                        exclude_attachments_from_queue: option.value,
                      }));
                    }}
                    icon="feather-check-circle"
                    value={emailformData.exclude_attachments_from_queue}
                    required
                  />
                </div>
              </div>
            </div>
            <hr className="my-5" />
            <div className="mb-5">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">Send Test Email</span>
              </h5>
              <div className="fs-12 text-muted">
                Send test email to make sure that your Email settings is set
                correctly.
              </div>
            </div>
            <div className="d-flex justify-content-center mb-5">
              <div className="col-md-1 mt-2">
                <label class="fw-semibold">Test Email:</label>
              </div>
              <div className="col-md-6">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Send Test Email"
                  />
                  <a href="#" className="input-group-text send-btn ">
                    Send Test
                  </a>
                </div>
              </div>
            </div>

            {/* Submit */}
            <div className="customButton">
              <button type="submit" className="btn btn-lg btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default EmailContent;
